import '../styles/footer.css';

const Footer = () => {
    return (
        <footer class="footer">
        <div class="footer-top">
            <div class="footer-container">
                <div class="footer-column">
                    <div class="footer-brand">
                        <h3>Portfolio<span class="accent">.</span></h3>
                        <p>Crafting digital experiences with clean and efficient code.</p>
                    </div>
                    <div class="footer-social">
                        <a href="https://github.com/PushpakB3096/" class="social-icon" title="GitHub">
                            <i class="fab fa-github"></i>
                        </a>
                        <a href="https://www.linkedin.com/in/pushpak-bhattacharya/" class="social-icon" title="LinkedIn">
                            <i class="fab fa-linkedin-in"></i>
                        </a>
                    </div>
                </div>

                <div class="footer-column">
                    <h4>Quick Links</h4>
                    <ul class="footer-links">
                        <li><a href="#home">Home</a></li>
                        <li><a href="#about">About</a></li>
                        <li><a href="#projects">Projects</a></li>
                        <li><a href="#contact">Contact</a></li>
                    </ul>
                </div>

                <div class="footer-column">
                    <h4>Contact Info</h4>
                    <ul class="footer-contact">
                        <li>
                            <i class="fas fa-envelope"></i>
                            <a href="mailto:rtpushpak@gmail.com">rtpushpak@gmail.com</a>
                        </li>
                        <li>
                            <i class="fas fa-map-marker-alt"></i>
                            <span>Bangalore, India</span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="footer-bottom">
            <div class="footer-container">
                <p>&copy; 2024 Pushpak Bhattacharya. All rights reserved.</p>
                <ul class="footer-legal">
                    <li><a href="#">Privacy Policy</a></li>
                    <li><a href="#">Terms of Service</a></li>
                    <li><a href="#">Cookie Policy</a></li>
                </ul>
            </div>
        </div>
    </footer>
    )
}

export default Footer;